



const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { status: { loggedIn: true }, user } : 
							{ status: {}, user: null };

export const authenticationStore = {
    namespaced: true,
    state: initialState,
    actions: {
    
    },
    mutations: {
        loginRequest(state, userT) {
            state.status = { loggingIn: true };
            state.user = userT;
        },
        loginSuccess(state, userT) {
            state.status = { loggedIn: true };
            state.user = userT;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },
        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
}